import { IconBase, IconComponent } from './BaseIcon';

export const ErrorCircle: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M16 30a14 14 0 1 1 14-14 14 14 0 0 1-14 14Zm0-26a12 12 0 1 0 12 12A12 12 0 0 0 16 4Zm-1.07 18.14a1.06 1.06 0 0 1 .27-.74 1 1 0 0 1 .79-.31 1 1 0 0 1 .81.31 1.1 1.1 0 0 1 .28.74 1.07 1.07 0 0 1-.28.73 1.06 1.06 0 0 1-.81.29 1 1 0 0 1-.79-.29 1 1 0 0 1-.27-.73ZM16.75 19h-1.63L15 8.84h1.89Z" />
  </IconBase>
);
